import { domUtils } from "./domUtils";

export const validators = {
  required: (value, element) => ({
    isValid: element.type === "checkbox" ? element.checked : value != null && value.toString().trim().length > 0,
    defaultMessage: "Required",
  }),

  email: (value, element) => ({
    isValid: !value || element?.checkValidity?.() !== false,
    defaultMessage: "Invalid email address",
  }),

  minLength: (value, element, min) => ({
    isValid: !value || (element?.checkValidity?.() !== false && value.length >= min),
    defaultMessage: `Must be at least ${min} characters`,
  }),

  maxLength: (value, element, max) => ({
    isValid: !value || (element?.checkValidity?.() !== false && value.length <= max),
    defaultMessage: `Must not exceed ${max} characters`,
  }),

  pattern: (value, element, pattern) => ({
    isValid: !value || (element?.checkValidity?.() !== false && pattern.test(value)),
    defaultMessage: "Please match the requested format",
  }),

  min: (value, element, min) => ({
    isValid: !value || (element?.checkValidity?.() !== false && Number(value) >= min),
    defaultMessage: `Must be at least ${min}`,
  }),

  max: (value, element, max) => ({
    isValid: !value || (element?.checkValidity?.() !== false && Number(value) <= max),
    defaultMessage: `Must not exceed ${max}`,
  }),

  checkboxset: (_, element) => {
    const parent = element.closest(".checkboxset");
    const checked = parent.querySelectorAll("input:checked").length;

    return {
      isValid: checked > 0,
      defaultMessage: "Please select one",
    };
  },
};

export const buildRules = (form) => {
  const rules = {};

  form.querySelectorAll("input:not([type=hidden]), textarea, select").forEach((field) => {
    if (!domUtils.shouldValidateField(field)) return;

    const fieldRules = [];

    if (field.required) fieldRules.push({ type: "required" });
    if (field.dataset.requiredIf) fieldRules.push({ type: "required" });
    if (field.type === "email") fieldRules.push({ type: "email" });
    if (field.minLength > 0) fieldRules.push({ type: "minLength", min: field.minLength });
    if (field.maxLength > 0) fieldRules.push({ type: "maxLength", max: field.maxLength });
    if (field.min) fieldRules.push({ type: "min", min: Number(field.min) });
    if (field.max) fieldRules.push({ type: "max", max: Number(field.max) });
    if (field.pattern) fieldRules.push({ type: "pattern", pattern: new RegExp(field.pattern) });

    if (fieldRules.length) {
      rules[field.name] = fieldRules;
    }
  });

  form.querySelectorAll("[aria-required], [data-required]").forEach((field) => {
    if (!domUtils.shouldValidateField(field)) return;

    const fieldRules = [];

    if (field.classList.contains("optionset") && !field.classList.contains("checkboxset")) {
      const radio = field.querySelector("input[type=radio]");

      if (radio) {
        fieldRules.push({ type: "required" });
        rules[radio.name] = fieldRules;
      }
    }

    if (field.classList.contains("checkboxset")) {
      const checkbox = field.querySelector("input[type=checkbox]");

      if (checkbox) {
        fieldRules.push({ type: "checkboxset" });
        rules[checkbox.name] = fieldRules;
      }
    }

    if (field.classList.contains("checkbox")) {
      fieldRules.push({ type: "required" });
      rules[field.name] = fieldRules;
    }
  });

  return rules;
};

export const validateRule = (value, element) => (rule) => {
  const { type, message, ...options } = rule;

  const validator = validators[type];
  if (!validator) return { isValid: true };

  const param = options.min || options.max || options.pattern;
  const result = validator(value, element, param);

  return {
    isValid: result.isValid,
    message: message || result.defaultMessage,
  };
};
